import React from "react";
import { Row, Col , Grid,PageHeader } from 'react-bootstrap'
import Carousel from 'nuka-carousel';
import ScrollAnimation from 'react-animate-on-scroll';

class Finalsale extends React.Component {

render() {
    
  return (


      <div className="finalsale Newarrive">
               <ScrollAnimation animateIn="fadeInUp"
               			animateOnce={true}>
                     


          <Grid>
                      <Row>

          <div className="Newarrive-holder">

              <div className="Newarrive-left">
              <Col md={6}>
              <h4>Final Summer Sale </h4>
              <p> 50% EXTRA on everything on sale </p> 
              <span> Outfits </span><span>  ... </span> 
              </Col>
              </div>
              <div className="Newarrive-right">

              <Col md={6}>
              <h4> </h4>

              <h4>Discover More...  </h4>
              </Col>
              </div>

              </div>


                <Carousel 
              slidesToShow={3}
      renderCenterLeftControls={({ previousSlide }) => (
        <button onClick={previousSlide}><i class="fa fa-angle-left"></i></button>
      )}
      renderCenterRightControls={({ nextSlide }) => (
        <button onClick={nextSlide}><i class="fa fa-angle-right"></i>

        </button>
      )}>
  
  
             <div className="finalsale__item">
              <div className="finalsale__item-wishlist">
              <h4>200 </h4>
              <img src={require("../../img/Home/white-heart.png")}/>
              </div>
              <div className="finalsale__item-main">

             <a href="/singleshop"> <img src={require("../../img/Home/sale1.png")}/> </a>
              </div>
              <div className="finalsale__item-hover">
                <i class="fa fa-heart" aria-hidden="true"></i>
                <i class="fa fa-shopping-bag" aria-hidden="true"></i>
               <a href="/singleshop"> <i class="fa fa-search" aria-hidden="true"></i> </a>
                </div>
                <div className="col-md-12 finalsale__item-details">
                  <a href="#"><h3>Outfit Name Here   </h3></a>
                  <span className="finalsale__was">2000.00 EGP </span>
                  <span className="finalsale__become">1000.00 EGP </span>

                </div>

              </div>

              

     
      
              <div className="finalsale__item">
              <div className="finalsale__item-wishlist">
              <h4>200 </h4>
              <img src={require("../../img/Home/white-heart.png")}/>
              </div>
              <div className="finalsale__item-main">

             <a href="/singleshop">  <img src={require("../../img/Home/sale2.png")}/> </a>
              </div>
                <div className="finalsale__item-hover">
                <i class="fa fa-heart" aria-hidden="true"></i>
                <i class="fa fa-shopping-bag" aria-hidden="true"></i>
               <a href="/singleshop"> <i class="fa fa-search" aria-hidden="true"></i> </a>
                </div>
                <div className="col-md-12 finalsale__item-details">
                  <a href="#"><h3>Outfit Name Here   </h3></a>
                  <span className="finalsale__was">2000.00 EGP </span>
                  <span className="finalsale__become">1000.00 EGP </span>

                </div>

              </div>

              

              <div className="finalsale__item">
              <div className="finalsale__item-wishlist">
              <h4>200 </h4>
              <img src={require("../../img/Home/white-heart.png")}/>
              </div>
              <div className="finalsale__item-main">

             <a href="/singleshop"> <img src={require("../../img/Home/sale3.png")}/> </a>
              </div>
                <div className="finalsale__item-hover">
                <i class="fa fa-heart" aria-hidden="true"></i>
                <i class="fa fa-shopping-bag" aria-hidden="true"></i>
               <a href="/singleshop"> <i class="fa fa-search" aria-hidden="true"></i> </a>
                </div>
                <div className="col-md-12 finalsale__item-details">
                  <a href="#"><h3>Outfit Name Here   </h3></a>
                  <span className="finalsale__was">2000.00 EGP </span>
                  <span className="finalsale__become">1000.00 EGP </span>

                </div>

              </div>

                 <div className="finalsale__item">
              <div className="finalsale__item-wishlist">
              <h4>200 </h4>
              <img src={require("../../img/Home/white-heart.png")}/>
              </div>
              <div className="finalsale__item-main">

             <a href="/singleshop"> <img src={require("../../img/Home/sale3.png")}/> </a>
              </div>
                <div className="finalsale__item-hover">
                <i class="fa fa-heart" aria-hidden="true"></i>
                <i class="fa fa-shopping-bag" aria-hidden="true"></i>
               <a href="/singleshop"> <i class="fa fa-search" aria-hidden="true"></i> </a>
                </div>
                <div className="col-md-12 finalsale__item-details">
                  <a href="#"><h3>Outfit Name Here   </h3></a>
                  <span className="finalsale__was">2000.00 EGP </span>
                  <span className="finalsale__become">1000.00 EGP </span>

                </div>

              </div>

              
      </Carousel>  



       
      
    
      
       </Row>

          </Grid>


 </ScrollAnimation>
                     
  </div>

      );
  }
}

export default Finalsale;



// WEBPACK FOOTER //
// ./src/Components/FinalSale/FinalSale.jsx